import * as React from "react";
import PropTypes from "prop-types";
import Context from "./Context";
import TrackerPropTypes from "./TrackerPropTypes";
export const TrackerProvider = ({
  tracker,
  children
}) => /*#__PURE__*/React.createElement(Context.Provider, {
  value: tracker
}, children);
TrackerProvider.propTypes = {
  children: PropTypes.node,
  tracker: PropTypes.shape(TrackerPropTypes)
};